import { useFilterCompanies } from "@/providers/contexts";
import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useCompanyFilterOptions } from "@/hooks";

// Only available to premium users
export const CompanyTypeFilter = () => {
  const { companyTypes } = useCompanyFilterOptions();

  const { filters: companyFilters, dispatch, loading } = useFilterCompanies();

  const { selectedCompanyTypes } = companyFilters;

  const options: AutocompleteOption[] = companyTypes.map(size => ({
    key: size.id,
    value: size.company_type_name,
  }));

  const selectedOptions = selectedCompanyTypes.map(selected => {
    const type = options.find(option => option.key === selected.id);

    return {
      key: type?.key ?? "",
      value: type?.value ?? "",
    };
  });

  return (
    <Autocomplete
      componentName="company-type"
      inputLabel="Company Type"
      options={options}
      value={selectedOptions}
      multiple
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = companyTypes.filter(type =>
          selectedValues.some(el => el.key === type.id),
        );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedCompanyTypes: selected },
        });
      }}
      loading={loading}
    />
  );
};
